import React, { useState, useEffect } from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import EditIcon from "@material-ui/icons/Edit";
import ReactHtmlParser from "react-html-parser";

import FileCopyIcon from "@material-ui/icons/FileCopy";
import {
  getDictationNotes,
  getNoteTemplatesByPractice,
  getNoteCategoryByPractice,
  updateDictationNotes,
  getDiagnosisByDescription,
  getProceduresByDescription,
  updateEncounterDetails,
  getEncounterText,
} from "apiHandler/actions";
import { useUserData } from "components/customHooks/userDataContext";
import EncounterModal from "components/modals/encounter/EncounterModal";
import ShowText from "components/modals/ShowText";
import { FormControlLabel, Radio, RadioGroup, Tooltip } from "@mui/material";

// import * as parse from 'html-react-parser';

const PatientNotes = ({
  dictation_id,
  practice_id,
  npi,
  encounter_id,
  setSuggDiag,
  setSuggProce,
  setLoading,
  readOnly,
  setEncounterId,
  details,
}) => {
  const [notes, setNotes] = useState(null);
  const [open, setOpen] = useState(true);
  const [notesError, setNotesError] = useState("");
  const [notesTemplates, setNotesTemplates] = useState(["SOAP"]);
  const [editModal, setEditModal] = useState(false);
  const [encounterModal, setEncounterModal] = useState(false);
  const [selectedNoteTemplate, setSelectedNoteTemplate] = useState("SOAP");
  const [categories, setCategories] = useState([
    "Subjective",
    "Objective",
    "Assessment",
    "Plan",
  ]);
  const [fetchedNotes, setFetchedNotes] = useState(null);
  const [encounterNote, setNote] = useState({});
  const [enhanceText, setEnhanceText] = useState();
  const [isEnhancing, setIsEnhancing] = useState(false);
  const [currentPlaying, setCurrentPlaying] = useState(null);

  const userData = useUserData();

  const token = userData?.access_token;

  useEffect(() => {
    fetchNotes();
  }, []);

  const fetchEncounterText = async () => {
    setIsEnhancing(true);
    console.log(encounterNote);
    const payload = {
      type: "Dictation",
      dictation_id,
      practice_id: practice_id || userData?.selected_practice,
      original_text: encounterNote.noteText,
      user_name: userData.first_name + " " + userData.last_name,
    };
    console.log(payload);
    const response = await getEncounterText(payload, token);
    console.log(response?.enhanced_text, "enhanced");
    setEnhanceText(response.enhanced_text);
    setIsEnhancing(false);
  };

  const fetchNotes = async () => {
    const payload = {
      type: "Dictation",
      search_criteria: {
        dictation_id,
        practice_id: practice_id || userData?.selected_practice,
        encounter_id,
        npi,
      },
    };
    const response = await getDictationNotes(payload, token);
    if (Array.isArray(response)) {
      if (response.length === 0) {
        const tempResponse = await getNoteTemplatesByPractice(
          {
            type: "Notes",
            search_criteria: {
              practice_id: practice_id || userData?.selected_practice,
            },
          },
          token,
        );
        setNotesTemplates(tempResponse?.template_names || ["SOAP"]);
        if (tempResponse?.template_names?.length === 1) {
          setSelectedNoteTemplate(tempResponse?.template_names?.[0] || "SOAP");
          setNotes({});
          onSelect();
        }
      } else {
        let tempNotes = {};
        setCategories(
          response.map((r) => {
            tempNotes[r.note_category] = r.note_text;
            return r.note_category;
          }),
        );
        setNotes(tempNotes);
        setFetchedNotes(response);
      }
    } else {
      setNotesError(`Failed to get patient notes: ${response?.error}`);
      setNotes({});
    }
  };

  const onSelect = async () => {
    const response = await getNoteCategoryByPractice(
      {
        type: "Notes",
        search_criteria: {
          practice_id:
            practice_id || userData?.selected_practiceselected_practice,
          template_name: selectedNoteTemplate,
        },
      },
      token,
    );
    if (response) {
      let temp = {};
      await setCategories(
        response.map((c) => {
          if (!c.note_sub_categories) temp[c.note_category] = "";
          else
            temp[c.note_category] =
              "<p><strong>" +
              c.note_sub_categories
                .split(", ")
                .join("</strong></p><p><br></p><p><br></p><p><strong>") +
              "</strong></p>";
          return c.note_category;
        }),
      );
      setNotes(temp);
      setNotesTemplates([selectedNoteTemplate]);
    }
  };

  const updateEncounterInfo = async () => {
    // const { id, practice_id, npi } = details;
    // const { first_name, last_name, dob } = personalInfo;
    let payload = {
      type: "Encounter",
      record_data: {
        practice_id: practice_id || userData?.selected_practice,
        npi,
        dictation_id,
        user_name: userData.first_name + " " + userData.last_name,
        scribe_id: userData.email,
      },
    };
    if (encounter_id) payload["record_data"]["encounter_id"] = encounter_id;
    const response = await updateEncounterDetails(payload, token);
    if (response !== "ERROR") {
      if (response?.encounter_id) setEncounterId(response.encounter_id);
      return response?.encounter_id;
    }
  };

  const updateNotes = async (payload, assessment, subjective) => {
    let encounter = encounter_id;
    if (!encounter) encounter = await updateEncounterInfo();
    await updateDictationNotes(payload, token);
    await setEditModal(false);
    fetchNotes();
    await setLoading(true);
    if (assessment) {
      let data = {
        type: "Diagnosis",
        search_criteria: {
          practice_id,
          encounter_id: encounter,
          dictation_id: dictation_id,
          user_name: userData.first_name + " " + userData.last_name,
          notes_description: assessment
            .replace(/<strong>|<\/strong>|<em>|<\/em>|<u>|<\/u>/g, "")
            .replace(/<[^]li>|<[^>]+>/g, ";")
            .replace(/;;/g, ";")
            .split(";")
            .filter((a) => a),
        },
      };
      const diagCodes = await getDiagnosisByDescription(data);
      await setSuggDiag(diagCodes && diagCodes !== "ERROR" ? diagCodes : []);
    }
    if (subjective) {
      let data = {
        type: "Procedure",
        search_criteria: {
          practice_id,
          encounter_id,
          dictation_id: dictation_id,
          user_name: userData.first_name + " " + userData.last_name,
          npi: npi,
          notes_description: subjective
            .replace(/<strong>|<\/strong>|<em>|<\/em>|<u>|<\/u>/g, "")
            .replace(/<[^]li>|<[^>]+>/g, ";")
            .replace(/;;/g, ";")
            .split(";")
            .filter((x) => x),
        },
      };
      const proceCodes = await getProceduresByDescription(data);
      await setSuggProce(
        proceCodes && proceCodes !== "ERROR" ? proceCodes : [],
      );
    }
    await setLoading(false);
  };

  const onButtonClick = async (notes) => {
    const blob = new Blob([notes], { type: "text/html" });

    navigator.clipboard.write([
      new window.ClipboardItem({
        [blob.type]: blob,
      }),
    ]);
  };

  const onCopyAll = async () => {
    try {
      if (!notes) return;

      // Build formatted plain text manually
      const plainText = Object.entries(notes)
        .map(([header, content]) => {
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = content;

          let text = tempDiv.innerText
            // Fix numbered lists (1. 2. etc)
            .replace(/(\d+\.\s*)/g, "\n$1")

            // Fix bullet points (• or -)
            .replace(/(•|-)\s*/g, "\n$1 ")

            // Remove extra new lines
            .replace(/\n{2,}/g, "\n")

            .trim();

          return `${header.toUpperCase()}\n${"-".repeat(header.length)}\n${text}`;
        })
        .join("\n\n\n"); // space between sections

      // Keep HTML version also (for rich paste)
      const htmlContent = Object.entries(notes)
        .map(([header, content]) => `<h3>${header}</h3>${content}`)
        .join("<hr/>");

      await navigator.clipboard.write([
        new ClipboardItem({
          "text/html": new Blob([htmlContent], { type: "text/html" }),
          "text/plain": new Blob([plainText], { type: "text/plain" }),
        }),
      ]);

      console.log("Copied with formatting!");
    } catch (error) {
      console.error("Copy failed:", error);
    }
  };

  const setCurrentNotes = (notes, c) => {
    console.log(notes[c], c);
    setNote({ noteText: notes[c], cat: c });
  };
  const setNoteText = (d, c) => {
    console.log(d, "ddddd");
    setNote({ noteText: d, cat: c });
  };
  return (
    <div className="dictation-notes">
      <div className="edit">
        <p>
          Patient Notes{" "}
          <Tooltip onClose={() => setOpen(false)} title={"Copy All"}>
            <FileCopyIcon
              fontSize="small"
              onClick={() => {
                onCopyAll();
              }}
              color="secondary"
              style={{ cursor: "pointer", marginLeft: 5 }}
            />
          </Tooltip>
        </p>
        {readOnly || (
          <EditIcon
            color="secondary"
            fontSize={"small"}
            onClick={() => setEditModal(true)}
          />
        )}
      </div>
      {notesError && <div className="error">{notesError}</div>}
      {notesTemplates.length > 1 ? (
        <div className="select-template">
          Select Template
          <RadioGroup
            name="templates"
            value={selectedNoteTemplate}
            onChange={(e) => setSelectedNoteTemplate(e.target.value)}
            style={{ flexDirection: "row", alignItems: "center" }}
          >
            {notesTemplates.map((t) => (
              <FormControlLabel
                key={t}
                value={t}
                control={<Radio />}
                label={t}
              />
            ))}
            <button onClick={onSelect} className="dict-temp-save">
              Select
            </button>
          </RadioGroup>
        </div>
      ) : (
        <div className="note-main-container">
          {categories.map((c) => (
            <div className="patient-notes-cont" key={c}>
              <p className="notes-title">
                {c}
                <Tooltip
                  id={c}
                  onClose={() => setOpen(false)}
                  // open={open === c}
                  // disableFocusListener
                  // disableHoverListener
                  // disableTouchListener
                  title={open ? `Copied ${c} data` : "Copy"}
                >
                  <FileCopyIcon
                    fontSize="small"
                    onClick={
                      () => {
                        setOpen(c);
                        onButtonClick(notes[c]);
                      }
                      //   {
                      //   setOpen(c)
                      //   navigator.clipboard.writeText(notes[c] ? ReactHtmlParser(JSON.parse(notes[c])) : 'No Data Found')
                      // }
                    }
                    color="secondary"
                    style={{ cursor: "pointer", marginLeft: 5 }}
                  />
                </Tooltip>
                <button
                  onClick={() => {
                    setEncounterModal(true);
                    setCurrentNotes(notes, c);
                    setEditModal(false);
                  }}
                  className="dict-temp-save"
                >
                  Enhance
                  {/* {isEnhancing ? <ButtonProgress size={14} /> : "Enhance"} */}
                </button>
              </p>
              <div className="notes-content">
                {notes === null ? (
                  <Skeleton />
                ) : notes[c] ? (
                  <div>{ReactHtmlParser(notes[c])}</div>
                ) : (
                  "No Data Found"
                )}
              </div>
              <div
                style={{ borderTop: "1px solid #D3D3D3", marginBottom: 5 }}
              ></div>
            </div>
          ))}
        </div>
      )}
      {editModal && (
        <ShowText
          text={details.dictation_text}
          onClose={() => setEditModal(false)}
          showPlayer={true}
          id={details.id}
          details={details}
          currentPlaying={currentPlaying}
          setCurrentPlaying={setCurrentPlaying}
          practice_id={details.practice_id}
          npi={details.npi}
          ext={details.file_extension}
          encounter_id={encounter_id}
          categories={categories}
          savedNotes={notes}
          updateNotes={updateNotes}
          fetchedNotes={fetchedNotes}
        />
      )}
      {encounterModal && (
        <EncounterModal
          id={dictation_id}
          practice_id={practice_id}
          encounter_id={encounter_id}
          npi={npi}
          savedNotes={notes}
          onClose={() => {
            setEncounterModal(false);
            setEnhanceText();
            setNote({});
          }}
          updateNotes={updateNotes}
          categories={categories}
          fetchedNotes={fetchedNotes}
          encounterNote={encounterNote}
          fetchEncounterText={fetchEncounterText}
          setNoteText={setNoteText}
          enhanceText={enhanceText?.enhanced_text}
          isEnhancing={isEnhancing}
        />
      )}
    </div>
  );
};

export default PatientNotes;
